import moment from "moment";
import {
  PublicBaseEventSerializer,
  NestedPublicVenueSerializer,
} from "@shared/modules/events/types/public";
import { PublicMembershipGroupSerializer } from "@shared/modules/memberships/types";
import { isPastEvent } from "@shared/modules/events/utils/event-utils";
import { enums } from "@shared/constants";
import { PublicVenueSerializer } from "@app-contexts/public/features/org-profile/data/types/public-venue";

export const getSEOTitle = ({
  eventData,
  membershipGroupData,
  venueData,
}: {
  eventData?: PublicBaseEventSerializer;
  membershipGroupData?: PublicMembershipGroupSerializer;
  venueData?: PublicVenueSerializer | NestedPublicVenueSerializer;
}): string => {
  let returnValue = "";

  if (
    eventData?.name &&
    eventData?.location &&
    eventData?.local_starts_on &&
    eventData?.timezone
  ) {
    returnValue = `${eventData.name} - ${eventData.location.name}${
      eventData.location?.city && ` - ${eventData.location.city}`
    } - ${moment
      .tz(eventData.local_starts_on, eventData.timezone)
      .format("MMM D, Y")}`;
  } else if (membershipGroupData?.name && venueData?.name) {
    returnValue = `${membershipGroupData.name} - ${venueData.name}`;
  }

  return returnValue;
};

export const getSEOTitleForSeatingMap = ({
  eventData,
  membershipGroupData,
}: {
  eventData?: PublicBaseEventSerializer;
  membershipGroupData?: PublicMembershipGroupSerializer;
}): string => {
  let returnValue = "";

  if (
    eventData?.name &&
    eventData?.location &&
    eventData?.local_starts_on &&
    eventData?.timezone
  ) {
    returnValue = `${eventData.name} - Select your Seats - ${
      eventData.location.name
    } - ${eventData.location.city} - ${moment
      .tz(eventData.local_starts_on, eventData.timezone)
      .format("MMM D, Y")}`;
  } else if (membershipGroupData?.name) {
    returnValue = `${membershipGroupData.name} - Select your Seats`;
  }

  return returnValue;
};

/**
 * Determines the Open Graph and Meta tag descriptions
 * @returns
 */
export const getSEODescription = ({
  eventData,
  membershipGroupData,
}: {
  eventData?: PublicBaseEventSerializer;
  membershipGroupData?: PublicMembershipGroupSerializer;
}): string => {
  let description = "";

  if (eventData) {
    description = `${eventData?.description_without_html ?? ""}`;
  } else if (membershipGroupData) {
    description = `${membershipGroupData?.description_without_html ?? ""}`;
  }

  return description;
};

export const shouldDisableSEO = ({
  eventData,
  membershipGroupData,
}: {
  eventData?: PublicBaseEventSerializer;
  membershipGroupData?: PublicMembershipGroupSerializer;
}): boolean => {
  // default: don't hide seo
  let returnVal = false;

  // for events, hide seo if:
  // event is in the past
  // event is not published
  // event is a child event
  if (eventData) {
    returnVal =
      isPastEvent(eventData) ||
      !eventData.is_published ||
      !!eventData.parent_event;
  }
  // for memberships, hide seo if:
  // membership is not published
  else if (membershipGroupData) {
    returnVal =
      membershipGroupData.status !==
      enums.MEMBERSHIP_GROUP_STATUS_MAP.PUBLISHED.id;
  }

  return returnVal;
};
